<template lang="pug">
modal(:active="true", title="Confirmação", @close="close")
  div(slot="modal-body")
    p.text Você está
      span.text-bold &nbsp;solicitando prazo para atender
      span &nbsp;sua notificação/auto
      span.text-bold &nbsp;{{ `${current.numero}/${current.ano}` }}
    p.text Isso abrirá uma Ordem de Serviço para o fiscal avaliar a sua solicitação
    p.text Após confirmar não será possível reverter este processo.
    p.text Tem certeza que deseja continuar?
  div(slot="modal-footer")
    a.btn.btn-link.text-error(@click="close")
      i.fa.fa-close
      |
      | Cancelar
    button.btn.btn-primary(@click="prazo")
      i.fa.fa-check
      |
      | Confirmar
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors";

export default {
  vuex: {
    docs: { state: ["current"], actions: ["fetchSolicitarPrazo"] },
  },
  methods: {
    async prazo() {
      try {
        await this.fetchSolicitarPrazo(this.current.id);
        this.$toaster.success(
          "Solicitação de prazo criada com sucesso"
        );
        this.close();
      } catch (e) {
        toastErrors([e]);
      }
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
